import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { BrandsRow, BrandsCol, BrandsHeader, BrandPageWrapper } from "./AllPartner.style";
import t from "../../i18n/translate";
import Partner from "../../components/Partner/Partner";
import API from "../../network/redAPI";
import Loader from './../../components/Loader/Loader';

const AllPartner = ({ props }) => {
  const history = useHistory();
  const [pageList, setPageList] = useState([]);
  const [limit] = useState(25); // Adjusted to load more items at once
  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const getListPartnerPages = useCallback(async () => {
    if (isLoading || !hasMore) return;
    setIsLoading(true);
    try {
      const body = {
        page_type: "partner_page",
        limit,
        page,
      };
      const response = await API.getPageSelection(body);
      const res = await response.json();

      if (res?.data?.data?.length > 0) {
        setPageList((prev) => [...prev, ...res.data.data]);
        setPage((prev) => prev + 1);
      } else {
        setHasMore(false);
      }
    } catch (error) {
      console.error("Failed to load partner pages:", error);
    } finally {
      setTimeout(() => {
        setIsLoading(false);
      },600)
    }
  }, [isLoading, hasMore, limit, page]);

  const handleScroll = useCallback(() => {
    if (
      window.innerHeight + document.documentElement.scrollTop >=
      document.documentElement.offsetHeight - 200 && // Adjust threshold
      !isLoading &&
      hasMore
    ) {
      getListPartnerPages();
    }
  }, [isLoading]);

  useEffect(() => {
    getListPartnerPages(); // Initial data fetch
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [getListPartnerPages, handleScroll]);

  return (
    <BrandPageWrapper>
      <BrandsHeader>{t('our_partner')}</BrandsHeader>
      <BrandsRow>
        {pageList &&
          pageList.length > 0 &&
          pageList.map((item, index) => {
            return (
              <BrandsCol key={item.id}>
                <Partner
                  item={item}
                  handleSelection={() => {
                    history.push(`/partner/${item.slug}`);
                  }}
                />
              </BrandsCol>
            );
          })}
      </BrandsRow>
      {isLoading && <div><Loader /></div>}
    </BrandPageWrapper>
  );
};

export default AllPartner;
